export default __webpack_public_path__ + "static/media/health.44b68a3d.svg";